import React from 'react';
import { Card, CardContent } from '../ui/card';

const ValueCard = ({ icon: Icon, title, description }) => (
  <Card className="bg-white">
    <CardContent className="p-8 text-center space-y-4">
      <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto">
        <Icon className="w-8 h-8 text-blue-600" />
      </div>
      <h3 className="text-xl font-bold text-gray-900">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </CardContent>
  </Card>
);

export default ValueCard;
